import React from "react";
import {withNamespaces} from "react-i18next";

const ValidationForm = ({t, validationKey, translatePrefix = "validation."}) => {
    return (
        validationKey ? (
            <small className="text-danger">
                { t(translatePrefix +validationKey)}
            </small>
        ) : (
            <React.Fragment/>
        )
    );
};
export default withNamespaces()(ValidationForm);
